import React from "react";
import SVGraphics from "../../assets/SVGraphics";

const BodyHeader = (props) => {
  return (
    <div className="flex w-full">
      <div className="text-[#FFF] text-[1.75rem] font-medium leading-tight">
        {props.title}
      </div>

      {props.includeSubtext && (
        <div className="ml-[10px] h-100 flex text-[#8F8F8F] text-[1rem] font-medium">
          {props.subText}
        </div>
      )}

      <div className="flex gap-4 ml-auto relative">
        {props.hasSearch && (
          <div className="w-93 h-10 flex flex-1 bg-[#2B2B2B] text-[#C1C1C1] items-center px-4 rounded-lg relative">
            <div className="pr-[5px]">
              <SVGraphics svgname="searchGlass" width="12px" height="12px" />
            </div>
            <input
              placeholder="Search"
              className="bg-transparent font-[14px] w-full outline-none"
              onChange={(e) => props.setSearchInput(e.target.value)}
              value={props.searchInput}
            />
            {props.searchMatches?.length > 0 && (
              <div className="absolute z-[1000] py-[10px] left-0 top-[100%] mt-1 text-white w-full max-h-60 overflow-y-auto flex flex-col bg-[#2B2B2B] rounded-[8px]">
                {props.searchMatches.map((item, i) => (
                  <div
                    key={
                      props.searchType === "site"
                        ? item.Site_name + i
                        : `${item.First_name}-${item.Last_name}-${i}`
                    }
                    className="cursor-pointer hover:bg-[#6c6c6c] flex px-[16px] py-[8px] gap-[12px] items-center"
                    onClick={() => props.onSearchItemClick(i)}
                  >
                    <div className="rounded-full bg-blue-700 w-[30px] h-[30px] flex items-center justify-center">
                      <SVGraphics svgname="UserIcon" width="18px" height="18px" />
                    </div>
                    <div className="flex flex-col">
                      {props.searchType === "user" ? (
                        <>
                          <div className="text-white font-medium text-sm">
                            {item.First_name} {item.Last_name}
                          </div>
                          <div className="text-[#C1C1C1] text-xs">{item.Email}</div>
                        </>
                      ) : (
                        <>
                          <div className="text-white font-medium text-sm">
                            {item.Site_name}
                          </div>
                          <div className="text-[#C1C1C1] text-xs">
                            {item.Site_country} – {item.Site_city}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {props.includeButton && !props.readOnly && (
          <div
            onClick={props.onButtonClick}
            className="flex justify-center cursor-pointer ml-auto w-31 min-h-2.5 p-2.5 text-center text-lg font-bold flex-shrink-0 rounded-lg bg-[#5A3EFF] shadow-black text-[#FFF]"
          >
            {props.includePlus && (
              <SVGraphics
                className="mt-1 w-2.5 h-2.5 cursor-pointer flex-shrink-0"
                fill="#FEFEFE"
                svgname="plusIcon"
              />
            )}
            <label className="ml-[12px] cursor-pointer text-center text-sm font-normal text-[#FFF]">
              {props.buttonText}
            </label>
          </div>
        )}
      </div>
    </div>
  );
};

export default BodyHeader;
